import type { ElementType, PropsWithChildren } from 'react'

interface SsrOnlyContentProps extends PropsWithChildren {
  as?: ElementType
  sectionName?: string
  testId?: string
}

export function SsrOnlyContent({
  as,
  children,
  sectionName,
  testId,
}: SsrOnlyContentProps) {
  if (!children) {
    return null
  }

  const Component = as ?? 'div'

  return (
    <Component
      hidden
      aria-hidden="true"
      data-ssr-only-content="true"
      data-ssr-section={sectionName}
      data-testid={testId}
    >
      {children}
    </Component>
  )
}
